import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AnalyticsEventRow, countBy, topEntries } from "@/hooks/useAnalyticsConversao";

interface Props {
  events: AnalyticsEventRow[];
}

const List: React.FC<{ title: string; items: Array<{ key: string; count: number }>; empty?: string }> = ({
  title,
  items,
  empty,
}) => (
  <Card>
    <CardHeader className="pb-2">
      <CardTitle className="text-base">{title}</CardTitle>
    </CardHeader>
    <CardContent>
      {items.length === 0 ? (
        <div className="text-sm text-muted-foreground">{empty || "Sem dados no período."}</div>
      ) : (
        <ul className="space-y-1.5">
          {items.map((it) => (
            <li key={it.key} className="flex justify-between text-sm border-b last:border-0 py-1">
              <span className="truncate mr-2" title={it.key}>
                {it.key}
              </span>
              <span className="font-semibold tabular-nums">{it.count}</span>
            </li>
          ))}
        </ul>
      )}
    </CardContent>
  </Card>
);

const TopListas: React.FC<Props> = ({ events }) => {
  const topPaths = topEntries(countBy(events.filter((e) => e.event_type === "page_view"), (e) => e.path), 10);
  const topTools = topEntries(
    countBy(
      events.filter((e) => e.event_type === "tool_access"),
      (e) => (e.metadata?.tool as string) || e.path
    ),
    10
  );
  const topReferrers = topEntries(
    countBy(events, (e) => {
      if (!e.referrer) return "(direto)";
      try {
        return new URL(e.referrer).hostname;
      } catch {
        return e.referrer;
      }
    }),
    10
  );
  const topUtm = topEntries(
    countBy(events, (e) => {
      const parts = [e.utm_source, e.utm_medium, e.utm_campaign].filter(Boolean);
      return parts.length ? parts.join(" / ") : null;
    }),
    10
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <List title="Top páginas" items={topPaths} />
      <List title="Top ferramentas" items={topTools} empty="Nenhum tool_access no período." />
      <List title="Origem / Referrer" items={topReferrers} />
      <List title="Top UTM (source / medium / campaign)" items={topUtm} empty="Sem UTM registrado no período." />
    </div>
  );
};

export default TopListas;
